import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IItemForGetShortDishInfo, IGetDishesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getDishesShortBySubCategoryIdV2 } from 'backend/dishes';
import { MultipleSelect } from './MultipleSelect';
import style from './index.module.scss';

interface IProps {
	setFetchedModificationsDishes: (value: IItemForGetShortInfo[]) => void;
	setModificationsDishCategory: (value: Nullable<string>) => void;
	setModificationsDishSubCategory: (value: Nullable<string>) => void;
	setModificationsDishes: (value: string[]) => void;
	removeModificationsDish: (value: string) => void;
	IDsSelectedRestaurant: string[];
	selectedModificationsDishCategory: Nullable<string>;
	selectedModificationsDishSubCategory: Nullable<string>;
	fetchedModificationsDishes: IItemForGetShortDishInfo[];
	selectedModificationsDishes: string[];
}

export const ModificationsDishMultipleSelect: React.FC<IProps> = React.memo(
	({
		setFetchedModificationsDishes,
		setModificationsDishCategory,
		setModificationsDishSubCategory,
		setModificationsDishes,
		removeModificationsDish,
		IDsSelectedRestaurant,
		selectedModificationsDishCategory,
		selectedModificationsDishSubCategory,
		fetchedModificationsDishes,
		selectedModificationsDishes,
	}) => {
		const { response, loading, refetch, responseError } = useFetchData<IGetDishesShort, string>(
			selectedModificationsDishSubCategory ? getDishesShortBySubCategoryIdV2 : null,
			selectedModificationsDishSubCategory || '',
		);

		useEffect(() => {
			refetch();
		}, [selectedModificationsDishSubCategory]);

		useEffect(() => {
			if (response) {
				setFetchedModificationsDishes(response.data.dishes);
			}
		}, [response]);

		return (
			<div className={style.container}>
				<div className={style.field}>
					<MultipleSelect
						refetch={refetch}
						setModificationsDishCategory={setModificationsDishCategory}
						setModificationsDishSubCategory={setModificationsDishSubCategory}
						setModificationsDishes={setModificationsDishes}
						removeModificationsDish={removeModificationsDish}
						data={
							selectedModificationsDishSubCategory && response?.data.dishes && !loading
								? response.data.dishes
								: []
						}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
						selectedModificationsDishCategory={selectedModificationsDishCategory}
						selectedModificationsDishSubCategory={selectedModificationsDishSubCategory}
						fetchedModificationsDishes={fetchedModificationsDishes}
						selectedModificationsDishes={selectedModificationsDishes}
						isLoading={loading}
						responseError={responseError}
					/>
				</div>
			</div>
		);
	},
);
